import { DateTime } from './ChartData';

type InputSource = {
  intervals: DateTime[];
  data: {
    time: DateTime;
  }[];
};

type GroupedSource<T extends InputSource> = {
  time: DateTime;
  data: T['data'];
}[];

function groupByTime<T extends InputSource>(source: T): GroupedSource<T> {
  return source.intervals.map((interval) => {
    const entries = source.data.filter((item) => item.time === interval);

    return {
      time: interval,
      data: entries,
    };
  });
}

export default groupByTime;
